/* eslint-disable max-len */
/* eslint-disable @scandipwa/scandipwa-guidelines/file-structure */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { cloneElement } from 'react';

import { Addresstype } from 'SourceType/Account.type';

import { updateShippingMethodCode } from '../store/CheckoutFields/CheckoutFields.action';

const propTypes = (member) => ({
    ...member,
    shippingAddress: Addresstype,
    billingAddress: Addresstype,
    updateShippingMethodCode: PropTypes.func.isRequired,
    shippingMethodCode: PropTypes.string.isRequired
});

const componentPropTypes = (member) => ({
    ...member,
    shippingAddress: Addresstype,
    billingAddress: Addresstype
});

const defaultProps = (member) => ({
    ...member,
    shippingAddress: null,
    billingAddress: null
});

const passAdressesProps = (args, callback, instance) => {
    const { billingAddress, shippingAddress } = instance.props;

    return {
        ...callback(...args),
        billingAddress,
        shippingAddress
    };
};

const passAdressesPropsToAddressBook = (args, callback, instance) => {
    const { shippingAddress, billingAddress } = instance.props;
    const prevRender = callback(...args);

    return cloneElement(
        prevRender,
        {
            ...prevRender.props,
            shippingAddress: shippingAddress || {},
            billingAddress: billingAddress || {}
        }
    );
};

const setShippingMethodFromTotals = (args) => {
    const { totals, shippingMethods, shippingMethodCode } = args[0];
    const { selectedShippingMethod } = args[1];
    const totalsMethodCode = shippingMethodCode
        || totals?.shipping_addresses?.selected_shipping_method?.method_code
        || null;

    // eslint-disable-next-line fp/no-let
    let methodCodeFromTotals = '';

    switch (totalsMethodCode) {
    case 'dhl_cod_courier_dhl_cod':
        methodCodeFromTotals = 'courier_dhl_cod';
        break;
    case 'dpd_cod_courier_dpd_cod':
        methodCodeFromTotals = 'courier_dpd_cod';
        break;
    case 'dhl_courier_dhl':
        methodCodeFromTotals = 'courier_dhl';
        break;
    case 'dpd_courier_dpd':
        methodCodeFromTotals = 'courier_dpd';
        break;
    case 'ruch_orlen_ruch':
        methodCodeFromTotals = 'orlen_ruch';
        break;
    case 'dhl_pickup_dhl':
        methodCodeFromTotals = 'pickup_dhl';
        break;
    default:
        methodCodeFromTotals = totalsMethodCode;
    }

    if (methodCodeFromTotals && !selectedShippingMethod?.method_code && shippingMethods?.length) {
        const filteredSelectedMethod = shippingMethods.find((method) => method.method_code === methodCodeFromTotals);

        if (filteredSelectedMethod?.method_code) {
            return {
                selectedShippingMethod: filteredSelectedMethod
            };
        }
    }

    return null;
};

const mapDispatchToProps = (args, callback, _instance) => {
    const [dispatch] = args;

    return {
        ...callback(...args),
        updateShippingMethodCode: (value) => dispatch(updateShippingMethodCode(value))
    };
};

const mapStateToProps = (args, callback, _instance) => {
    const [state] = args;

    return {
        ...callback(...args),
        shippingMethodCode: state.CheckoutFieldsReducer.shippingMethodCode
    };
};

export default {
    'Component/CheckoutShipping/Container': {
        'static-member': {
            propTypes,
            defaultProps,
            getDerivedStateFromProps: setShippingMethodFromTotals
        },
        'member-function': {
            containerProps: passAdressesProps
        }
    },
    'Component/CheckoutShipping/Component': {
        'static-member': {
            propTypes: componentPropTypes,
            defaultProps
        },
        'member-function': {
            renderAddressBook: passAdressesPropsToAddressBook
        }
    },
    'Component/CheckoutShipping/Container/mapDispatchToProps': {
        function: mapDispatchToProps
    },
    'Component/CheckoutShipping/Container/mapStateToProps': {
        function: mapStateToProps
    }
};
